import mixpanel from "./clients";
import trackFirehose from './kinesis'
import { createAction } from "redux-delta";
import { takeEvery, select, call } from "redux-saga/effects";
import { mapRemoveHours, mapCreateHours, mapEditHour, mapDay } from "./mappers";
import { selectDailyTextsData } from "../dailytexts";

export const identify = createAction("IDENTIFY");
function* identifySaga({ payload }) {
  mixpanel.identify(payload);
}

export const peopleSet = createAction("PEOPLE_SET");
function* peopleSetSaga({ payload }) {
  mixpanel.people.set(payload);
}

export const peopleAppend = createAction("PEOPLE_APPEND");
function* peopleAppendSaga({ payload }) {
  mixpanel.people.append.apply(mixpanel.people, payload);
}

export const peopleInc = createAction("PEOPLE_INC");
function* peopleIncSaga({ payload }) {
  mixpanel.people.increment(payload);
}

export const track = createAction("TRACK");
function* rawTrackSaga({ payload }) {
  if (payload && payload.name) {
    trackFirehose(payload.name, payload.attrs || {});
    mixpanel.track(payload.name, payload.attrs || {});
  }
}

export const trackSaga = (name, mapToAnalytics=v=>v) =>
  function*() {
    const stateData = yield select(selectDailyTextsData)
    let p = mapToAnalytics(stateData)
    trackFirehose(name, p);
    mixpanel.track(name, p);
  };

export function* trackRemoveHourSaga({ payload }) {
  yield call(trackSaga("Settings Webview Delete Hour", mapRemoveHours(payload)))
}

export function* trackAddHourSaga({ payload }) {
  yield call(trackSaga("Settings Webview Add Hour", mapCreateHours(payload)))
}

export function* trackEditHourSaga({ payload }) {
  yield call(trackSaga("Settings Webview Edit Hour", mapEditHour(payload)))
}

export function* trackAddDaySaga({ payload }) {
  yield call(trackSaga("Settings Webview Add Day", mapDay(payload)))
}

export function* trackRemoveDaySaga({ payload }) {
  yield call(trackSaga("Settings Webview Remove Day", mapDay(payload)))
}

export default function*() {
  yield takeEvery(identify.type, identifySaga);
  yield takeEvery(peopleSet.type, peopleSetSaga);
  yield takeEvery(peopleAppend.type, peopleAppendSaga);
  yield takeEvery(peopleInc.type, peopleIncSaga);
  yield takeEvery(track.type, rawTrackSaga);
}





// WEBPACK FOOTER //
// ./src/store/mixpanel/index.js